module.exports = __webpack_public_path__ + "media/images/patterns/7-83146f49631478af28c0306b80646755.png";